define('controllers/conversations/Podio.Controllers.Conversations.ConversationCollection',['require','underscore','jquery','backbone','lib/Podio.Time','lib/backbone/Backbone.PodioController','collections/Podio.Collections.Conversations','collections/Podio.Collections.ConversationEvents','models/Podio.Models.Conversation','models/Podio.Models.ConversationEvent','lib/backbone/Backbone.PodioCollection','lib/Podio.Config','lib/Podio.Routes'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var podioTime = require('lib/Podio.Time');

  var PodioController = require('lib/backbone/Backbone.PodioController');
  var CollectionConversations = require('collections/Podio.Collections.Conversations');
  var CollectionConversationEvents = require('collections/Podio.Collections.ConversationEvents');
  var ModelConversation = require('models/Podio.Models.Conversation');
  var ModelConversationEvent = require('models/Podio.Models.ConversationEvent');
  var BackboneCollection = require('lib/backbone/Backbone.PodioCollection');
  var Config = require('lib/Podio.Config');
  var routes = require('lib/Podio.Routes');

  return PodioController.extend({

    pushEvents: {
      'user': {
        'conversation_event': 'onPushEventAdded',
        'conversation_unread_count': 'onPushUnreadCountChanged',
        'conversation_starred_count': 'onPushStarredCountChanged',
        'conversation_starred': 'onPushConversationStarred',
        'conversation_unstarred': 'onPushConversationUnstarred',
        'conversation_read': 'onPushConversationRead',
        'conversation_unread': 'onPushConversationUnread',
        'conversation_read_all': 'onPushConversationReadAll'
      }
    },

    initialize: function(options) {
      var itemsPerRequest = options.itemsPerRequest || 25;
      this.eventsPerConversation = {};

      this.collections = {
        all: new CollectionConversations([], {flag: null, itemsPerRequest: itemsPerRequest, maxItems: options.maxItems}),
        starred: new CollectionConversations([], {flag: 'starred', itemsPerRequest: itemsPerRequest, maxItems: options.maxItems}),
        unread: new CollectionConversations([], {flag: 'unread', itemsPerRequest: itemsPerRequest, maxItems: options.maxItems})
      };

      this.loadQueue = new BackboneCollection();

      _.bindAll(this, 'onPushEventAdded', 'onPushUnreadCountChanged', 'onPushStarredCountChanged', 'onPushConversationStarred', 'onPushConversationUnstarred', 'onPushConversationRead', 'onPushConversationUnread', 'onPushConversationReadAll', 'refetchConversation');

      this._super();
    },

    _getCollectionForFlag: function(flag) {
      switch (flag) {
      case 'starred':
        return this.collections.starred;
      case 'unread':
        return this.collections.unread;
      default:
        return this.collections.all;
      }
    },

    _withFetchedConversation: function(conversationId, callback) {
      var conversation = new ModelConversation({ id: conversationId });
      conversation.fetch().done(callback.curry(conversation, this));
    },

    _withCachedOrFetchedConversation: function(conversationId, callback) {
      var cachedConversation, freshConversation;
      _.every(this.collections, function(collection, key) {
        cachedConversation = collection.find(function(conversation) { return conversation.get('id') === conversationId; });
        return !cachedConversation;
      });

      if (cachedConversation) {
        callback(cachedConversation, this);
      } else {
        freshConversation = new ModelConversation({ id: conversationId });
        freshConversation.fetch().done(callback.curry(freshConversation, this));
      }
    },

    _parseDate: function(date) {
      return podioTime.localMomentFromAPIString(date);
    },

    // will syncronize requests between manual fetching and the push so no unnecessary requests are made
    // is also managing the load queue
    _syncRequests: function(collection, id, pushTimestamp) {
      var dfd = new $.Deferred();
      var promises;
      var item = collection.get(id);

      // is it being fetched right now and the push arrived early?
      if (!this.loadQueue.isEmpty()) {
        promises = _.pluck(this.loadQueue.models, 'lastPromise');
        // wait for all requests in the queue to complete (so they have IDs) and check if our item was there
        $.when.apply(this, promises).done(function() {
          var foundItem = collection.get(id);

          if (foundItem) {
            dfd.resolve(foundItem);
          } else {
            dfd.reject();
          }
        });
      }
      // if item is already in the collection
      // (new conversation created in the same tab finished fetching or we created a new event)
      else if (item) {
        // the item is an event, no need to check on the timestamp, since they cannot be edited
        if (!item.get('last_event_on')) {
          dfd.resolve(item);
          return dfd;
        }

        // has it been created in the same tab and already fetched?
        // is the date on the model older than the date in the push? then refetch
        if (this._parseDate(item.get('last_event_on')).diff(this._parseDate(pushTimestamp), 'seconds') < 0) {
          dfd.reject();
        } else {
          dfd.resolve(item);
        }
      } else {
        dfd.reject();
      }

      return dfd;
    },

    // Handles both new conversation created and message added to existing conversation
    // pushData: { conversation_id, event_id }
    onPushEventAdded: function(pushData) {
      var self = this;
      var conversationId = pushData.conversation_id;
      var eventId = pushData.event_id;
      var createdOn = pushData.created_on;
      var unreadCount = pushData.unread_count;
      var totalUnreadCount = pushData.total_unread_count;
      var conversationReady;

      // do not fetch anything if it's the leave event
      if (pushData.action === 'participant_leave' && pushData.created_by.id === Config.user.user_id) {
        this.onPushParticipantLeave(conversationId);
        return false;
      }

      conversationReady = this._syncRequests(this.collections.all, conversationId, createdOn);
      conversationReady.done(function(conversation) {
        conversation.set('unread_count', unreadCount); // Make sure cached conversation has correct unread count
        self.afterPushEvent(conversation, eventId, createdOn, totalUnreadCount);
      }).fail(function() {
        // Load conversation data
        self._withFetchedConversation(conversationId, function(conversation, self) {
          self.afterPushEvent(conversation, eventId, createdOn, totalUnreadCount);
        });
      });
    },

    afterPushEvent: function(conversation, eventId, createdOn, totalUnreadCount) {
      // Set the total unread count on the collection, since we cannot supply custom parameters to the backbone sort event
      this.collections.all.totalUnreadCount = totalUnreadCount;

      // Add to appropriate collections (or update existing models)
      this.addConversation(conversation);

      this.eventBus.trigger('conversationsCollection:eventAdded', conversation, eventId, createdOn, totalUnreadCount);
    },

    // Push whenever unread count changes
    // unreadCount = 0 means mark all as read
    onPushUnreadCountChanged: function(pushData) {
      this.trigger('conversationsCollection:unreadCountChanged', pushData.count);
    },

    // Push whenever starred count changes
    onPushStarredCountChanged: function(pushData) {
      this.trigger('conversationsCollection:starredCountChanged', pushData.count);
    },

    onPushConversationStarred: function(pushData) {
      this._withCachedOrFetchedConversation(pushData.conversation_id, function(conversation, self) {
        conversation.set('starred', true);
        self.addConversationToSingleCollection(conversation, 'starred');
      });
    },

    onPushConversationUnstarred: function(pushData) {
      this._withCachedOrFetchedConversation(pushData.conversation_id, function(conversation, self) {
        conversation.set('starred', false);
        self.removeConversationFromSingleCollection(conversation, 'starred');
      });
    },

    onPushConversationUnread: function(pushData) {
      this._withCachedOrFetchedConversation(pushData.conversation_id, function(conversation, self) {
        conversation.set('unread', pushData.unread_count > 0);
        conversation.set('unread_count', pushData.unread_count);
        self.addConversationToSingleCollection(conversation, 'unread');
      });
    },

    onPushConversationRead: function(pushData) {
      this._withCachedOrFetchedConversation(pushData.conversation_id, function(conversation, self) {
        conversation.set('unread', pushData.unread_count > 0);
        conversation.set('unread_count', pushData.unread_count);
        self.removeConversationFromSingleCollection(conversation, 'unread');
      });
    },

    onPushConversationReadAll: function() {
      this.resetASingleCollection('unread');
      this.markAllRead({surpressRequest: true});
      this.trigger('conversationsCollection:conversationReadAll');
    },

    onPushParticipantLeave: function(conversationId) {
      // this is non-destructive, so if the conversation is gone already it's gonna be fine
      this.leaveConversationById(conversationId);
      this.trigger('conversationsCollection:leftConversation', conversationId);
    },

    clearEventsCache: function(conversationId) {
      this.eventsPerConversation[conversationId] = null;
    },

    getConversations: function(options) {
      options = options || {};

      var dfd = new $.Deferred();
      var collection = this._getCollectionForFlag(options.flag);

      collection.setFilter(options.filter);

      if (collection.isEmpty()) {
        collection.loadChunk().done(function() {
          dfd.resolve(collection);
        });
        return dfd;
      } else {
        return dfd.resolve(collection);
      }
    },

    setConversations: function(conversations, options) {
      var collection = this._getCollectionForFlag(options.flag);
      var resetOptions = {};

      if (options.silent) {
        resetOptions.silent = true;
      }

      collection.reset(conversations, resetOptions);
    },

    getConversationById: function(flag, id) {
      var collection = this._getCollectionForFlag(flag);

      return collection.get(id);
    },

    createConversation: function(dataOrModel, callback) {
      var self = this;
      var response;
      var conversationModel = dataOrModel instanceof Backbone.Model ? dataOrModel : new ModelConversation(dataOrModel);
      this.loadQueue.add(conversationModel);

      conversationModel.save().done(function(responseData) {
        if (responseData.status === 'ok') {
          conversationModel.set(responseData.data.conversation);

          conversationModel.set({ fresh: true });
          self.addConversation(conversationModel);
          conversationModel.set({ fresh: false });
          self.loadQueue.remove(conversationModel);

          response = conversationModel;
          self.trigger('conversationCollection:conversationCreated', response);
        } else {
          response = null;
        }

        callback(response, !responseData.error_propagate);
      });
    },

    refetchConversation: function(conversation) {
      var self = this;
      this.loadQueue.add(conversation);
      conversation.fetch().done(function() {
        self.sortAllConversationCollections();
        self.loadQueue.remove(conversation);
      });
    },

    createEvent: function(data, conversationId) {
      var self = this;
      var dfd = new $.Deferred();
      var event;

      event = this.eventsPerConversation[conversationId].create(data, {
        wait: true,
        at: 0,
        success: function() {
          self.loadQueue.remove(event);
          dfd.resolve(event);
        },
        fresh: true
      });
      this.loadQueue.add(event);

      return dfd;
    },

    handleMessagePushEvent: function(eventsCollection, eventId, createdOn) {
      var dfd = new $.Deferred();
      var eventReady = this._syncRequests(eventsCollection, eventId);

      // if the promise is resolved then the events have been already loaded and rendered
      // otherwise fetch, add and render the event manually
      eventReady.fail(function() {
        var event = new ModelConversationEvent({ id: eventId, created_on: createdOn });

        // have to add it to the collection right now so we have the right URL to fetch
        eventsCollection.add(event, { silent: true });
        event.fetch().done(function() {
          eventsCollection.sort();
          dfd.resolve(event);
        });
      });

      return dfd;
    },

    getConversationEvents: function(conversationId, options) {
      options = options || {};
      var dfd = new $.Deferred();
      var eventsCol = this.eventsPerConversation[conversationId];

      if (eventsCol && !options.forceFetch) {
        return dfd.resolve(eventsCol);
      } else {
        var self = this;
        eventsCol = new CollectionConversationEvents([], { id: conversationId });
        eventsCol.fetch({ reset: true }).done(function() {
          self.eventsPerConversation[conversationId] = eventsCol;
          dfd.resolve(eventsCol);
        });
        return dfd;
      }
    },

    addConversation: function(conversation) {
      this.collections.all.add(conversation, { merge: true });

      if (conversation.get('starred')) {
        this.collections.starred.add(conversation, { merge: true });
      }

      if (conversation.get('unread')) {
        this.collections.unread.add(conversation, { merge: true });
      }

      return this.collections.all.get(conversation.id);
    },

    addConversationToSingleCollection: function(conversation, collection, options) {
      this.collections[collection].add(conversation, options);
    },

    removeConversationFromSingleCollection: function(conversation, collection, options) {
      this.collections[collection].remove(conversation, options);
    },

    resetASingleCollection: function(collection) {
      this.collections[collection].reset();
    },

    markAllRead: function(options) {
      return this.collections.all.markAllRead(options);
    },

    addParticipants: function(conversationId, participants) {
      // this is done outside of the conversation model as it will return an event
      var transport = this.request(
        'post',
        routes.conversations_add_participant_path(conversationId),
        { participants: participants }
      );

      return this._addPromisedEventToConversation(transport, conversationId);
    },

    changeSubject: function(conversationId, subject) {
      // this is done outside of the conversation model as it will return an event
      var transport = this.request(
        'put',
        routes.subject_conversation_path(conversationId),
        { subject: subject }
      );

      return this._addPromisedEventToConversation(transport, conversationId);
    },

    _addPromisedEventToConversation: function(eventPromise, conversationId) {
      var self = this;

      eventPromise.done(function(responseData) {
        if (responseData.status === 'ok') {
          var eventsCol = self.eventsPerConversation[conversationId];
          eventsCol.add(responseData.data.object, { fresh: true });
        }
      });

      return eventPromise;
    },

    sortAllConversationCollections: function() {
      _.each(this.collections, function(collection, key) {
        collection.sort();
      });
    },

    leaveConversation: function(conversation) {
      _.each(this.collections, function(collection, key) {
        collection.remove(conversation);
      });
    },

    leaveConversationById: function(conversationId) {
      _.each(this.collections, function(collection, key) {
        var model = collection.get(conversationId);
        collection.remove(model);
      });
    },

    // Returns a direct conversation for the given userId as a deferred
    // Done gets a second returned telling the state of the conversation:
    // - listed: The conversation was found in the client-side list of conversation
    // - unlisted: The conversation exists, but is not currently rendered in the client-side list
    // Fail means that these two users do not have an existing direct conversation
    findDirectConversationForUser: function(userId) {
      var dfd = new $.Deferred();
      var conversation;

      // Do we already have this conversation in the client-side list?
      conversation = this.collections.all.find(function(conversation) {
        return conversation.isDirect() && conversation.getOtherParticipant().get('user_id') === userId;
      });
      if (conversation) {
        return dfd.resolve(conversation, 'listed');
      }

      // Does the users have an existing direct conversation which is not in the list?
      var transport = this.request('get', routes.direct_conversation_path(userId));
      transport.done(function(responseData) {
        if (responseData.status === 'ok') {
          // Yes, return the existing conversation
          conversation = new ModelConversation(responseData.data.object);
          dfd.resolve(conversation, 'unlisted');
        } else {
          // No, fail the deferred
          dfd.reject();
        }
      });

      return dfd;
    },

    findOrCreateDirectConversationForUser: function(userId) {
      var self = this;
      var eventsCol;
      var dfd = new $.Deferred();

      this.findDirectConversationForUser(userId).done(function(conversation, state) {
        dfd.resolve(conversation, state);
      }).fail(function() {
        self.createConversation({
          'participant_list': 'user|' + userId
        }, function(conversation, errorNotPropagated) {
          if (_.isNull(conversation)) {
            dfd.reject();
          } else {
            // create an empty events collection for the new conversation
            eventsCol = new CollectionConversationEvents([], { id: conversation.get('conversation_id') });
            self.eventsPerConversation[conversation.get('conversation_id')] = eventsCol;
            dfd.resolve(conversation, 'listed');
          }
        });
      });

      return dfd;
    }
  });

});

